<script lang="ts">
	import { getCopyFromSmoreStore } from "../connect/copyFromSmoreStore";
	import { getToastStore } from "./toastStore";

	const toastStore = getToastStore();
	const copyStore = getCopyFromSmoreStore();
	const progress = copyStore.getCopyNewslettersProgress();
	copyStore.checkForExistingCopyRequest();

	async function toastClosed(itemId: string) {
		await copyStore.markOperationAsSeen(itemId);
	}

	$: if (!$copyStore.progressPopupOpen && ["completed", "failed"].includes($progress?.status || "")) {
		if ($progress?.status === "completed" || $progress?.completedAt) {
			toastStore.push("<p class='flex items-center shrink-0'>Your folders and newsletters were copied to Connect 🎉</p>", {
				id: $progress.id,
				type: "info",
				autoClose: false,
				onClose: toastClosed,
				cssClasses: [
					"bg-[#1C8313] text-white [&_.border-message]:border-[#11992F]",
					"[&_a]:border [&_a]:rounded-lg [&_a]:px-4 [&_a]py-2 [&_a]:border-gray-200"
				]
			});
		}
		if ($progress?.status === "failed" || $progress?.failedAt) {
			toastStore.push(
				"<p class='flex items-center w-full shrink-0'>Uh-oh! Looks like there was an issue<br/>copying some of your content. <a href='mailto:support@smore.com'>Contact Support</a></p>",
				{
					id: $progress.id,
					type: "error",
					autoClose: false,
					onClose: toastClosed,
					cssClasses: [
						"bg-[#B91C25] text-white [&_.border-message]:border-[#DC2631]",
						"[&_a]:border [&_a]:rounded-lg [&_a]:px-4 [&_a]py-2 [&_a]:border-[#F87179] [&_a]:ml-4"
					]
				}
			);
		}
	}
</script>
